import React, { useState, useEffect } from 'react';

import Help from './Help.js'

// ----------------------------------------------------------------------------------
//     (c) DXA Development 2023
// ----------------------------------------------------------------------------------

function Index(props) {

    // ---------- return html (jsx) ----------

    return (
        <Help {...props} />
    )

    };  // end of function

    export default Index